<template>
  <div class="">
    <table>
      <template v-for="(items, group) in groupedData">
        <tr :key="group">
          <th colspan="3">{{ group }}</th>
        </tr>
        <template v-for="(item, index) in items">
          <tr :key="index">
            <td>{{ item.name }}</td>
            <td>{{ item.price_per }}</td>
            <td class="text-end">{{ item.quantity }}x</td>
          </tr>
        </template>
      </template>
      <tfoot>
      <tr>
        <th scope="row" colspan="2">Summe (netto)</th>
        <td class="text-end">{{ centToEuroString(groupedDataSum.net_cent) }}</td>
      </tr>
      <tr>
        <th scope="row" colspan="2">Summe (brutto)</th>
        <td class="text-end">{{ centToEuroString(groupedDataSum.gross_cent) }}</td>
      </tr>
      </tfoot>
    </table>
  </div>
</template>
<script>
export default {
  props: {
    'step': Object,
    'title': String,
  },
  data() {
    return {
      formatter: new Intl.NumberFormat('de-DE', {
        style: 'currency',
        currency: 'EUR',
      })
    };
  },
  created() {
    this.handleUserData()
  },
  methods: {
    centToEuroString(cent) {
      const euro = cent / 100
      return this.formatter.format(euro)
    },
    handleUserData() {
      this.showNextDisabledHint = false
      let groupIndex = this.step.index + 100
      Object.entries(this.groupedData).forEach(([groupLabel, group]) => {
        groupIndex++
        let itemIndex = 0
        this.$store.commit('updateUserInput', {
          name: 'blocks[' + groupIndex + '][label]',
          module: this.step.type,
          input: groupLabel,
        });
        Object.values(group).forEach((item) => {
          itemIndex++;
          this.$store.commit('updateUserInput', {
            name: 'blocks[' + groupIndex + '][items][' + itemIndex + '][name]',
            module: this.step.type,
            input: `${item.name} | ${this.centToEuroString(item.net_price_cent)} netto`,
          });
          this.$store.commit('updateUserInput', {
            name: 'blocks[' + groupIndex + '][items][' + itemIndex + '][count]',
            module: this.step.type,
            input: item.quantity,
          });
        })
      })

      const groupedDataSum = this.groupedDataSum

      groupIndex++
      this.$store.commit('updateUserInput', {
        name: 'blocks[' + groupIndex + '][label]',
        module: this.step.type,
        input: `Anfragevolumen (netto): ${this.centToEuroString(groupedDataSum.net_cent)}`,
      });

      groupIndex++
      this.$store.commit('updateUserInput', {
        name: 'blocks[' + groupIndex + '][label]',
        module: this.step.type,
        input: `Anfragevolumen (brutto): ${this.centToEuroString(groupedDataSum.gross_cent)}`,
      });

      this.step.deleteFromSummary(this.title)
      this.step.addToSummary({
        label: this.title,
        text: `Leistungen im Wert von ${this.centToEuroString(groupedDataSum.net_cent)} netto / ${this.centToEuroString(groupedDataSum.gross_cent)} brutto`,
        noClear: true,
        noEdit: true,
      });
    },
  },
  computed: {
    groupedData() {
      return this.$store.state.menuOrder ?? {}
    },
    groupedDataSum() {
      const data = this.groupedData
      const total = {
        net_cent: 0,
        gross_cent: 0
      }

      for (const category in data) {
        for (const item in data[category]) {
          const details = data[category][item];
          const quantity = parseInt(details.quantity, 10);
          const netPrice = parseInt(details.net_price_cent, 10);
          const grossPrice = parseInt(details.gross_price_cent, 10);

          total.net_cent += quantity * netPrice;
          total.gross_cent += quantity * grossPrice;
        }
      }

      return total
    }
  }
}
</script>